import { Flex, Modal } from "antd";
import { FC } from "react";
import { postWorkStopThunk } from "tm-shared/api";

import { useAsyncAction } from "@/hooks";
import { useAppDispatch, useProtectedUserRoleSelector } from "@/hooks/redux";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledButton } from "./Styled";

interface ForceStopWorkModalProps {
    onClose: () => void;
}

export const ForceStopWorkModal: FC<ForceStopWorkModalProps> = ({
    onClose,
}) => {
    const dispatch = useAppDispatch();
    const role = useProtectedUserRoleSelector();

    const [handleForceEndWork, isProcessingEndWork] = useAsyncAction(
        async () => {
            await dispatch(postWorkStopThunk({ force: true, roleSlug: role }));
            onClose();
        },
    );

    return (
        <Modal
            title=""
            open
            onOk={onClose}
            onCancel={onClose}
            centered
            closable={false}
            footer={[]}
        >
            <PrimaryText
                fontSize={20}
                fontWeight="500"
                lineHeight="20px"
                textAlign="center"
                padding="0 0 16px 0"
            >
                Ви маєте невиконані завдання
            </PrimaryText>
            <Flex gap="10px" justify="center" align="center">
                <StyledButton type="text" onClick={onClose}>
                    Продовжити роботу
                </StyledButton>
                <StyledButton
                    onClick={handleForceEndWork}
                    loading={isProcessingEndWork}
                    type="primary"
                    danger
                >
                    Все одно вийти
                </StyledButton>
            </Flex>
        </Modal>
    );
};
